import { createAction } from '@mews-framework/redux';
import { SetSentryUserProps } from '../../../services';

export const USER_SET = '@@sentry/USER_SET';

export const setSentryUser = (sentryUser: SetSentryUserProps) => createAction(USER_SET, sentryUser);

export type SetSentryUserAction = ReturnType<typeof setSentryUser>;
